<template>
	<div class="partrecommended">
		<HNB></HNB>
		<div class="nav" v-show="navstyle">
			<div class="navshell" style="width: 85%;margin: 0 auto;">
				<div class="nav-list" v-for="(item,i) in part" @click="choosepart(item.link)">
					<span :class="{'active':partflag==item.link}">{{item.write}}</span>
				</div>
			</div>
		</div>
		<div class="title">部位选择</div>
		<div class="centerpart" style="padding-bottom: 5rem;">
			<div class="part"  v-for="(item,i) in part" @click="choosepart(item.link)" :class="{'active':partflag==item.link}">
				<img :src="partflag==item.link?item.imgactive:item.img" />
				<div class="part-write" :class="{'active':partflag==item.link}">{{item.write}}</div>
			</div>
		</div>
		<div class="product" v-for="(item,i) in producttotal" v-show="item.choose==partflag" >
			<positionView :imgs="item.imgs" :shopsTitle="item.shopsTitle" :leftList="item.leftList" :svgName="item.svgName" :cactive="item.cactive" :url="item.url"/>
		</div>
		<bottom :BsTitle="bsTitle"></bottom>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	import positionView from '../components/PositionView.vue'
	
	export default {
		name: 'partrecommended',
		components: {
			HNB,
			bottom,
			positionView
		},
		data() {
			return {
				navstyle: false,
				partflag: '',
				// partindex: '',
				bsTitle: ['首页', '部位推荐'],
				part: [{
						icon: '&#xe60c;',
						write: '全身',
						img: this.GLOBAL.imgHost + '/images/product/quanshen.png',
						imgactive: this.GLOBAL.imgHost + '/images/product/quanshen2.png',
						link:'quanshen'
					},
					{
						icon: '&#xe60e;',
						write: '头部',
						img: this.GLOBAL.imgHost + '/images/product/head.png',
						imgactive: this.GLOBAL.imgHost + '/images/product/head2.png',
						link:'head'
					},
					{
						icon: '&#xe606;',
						write: '肩部',
						img: this.GLOBAL.imgHost + '/images/product/jianbu.png',
						imgactive: this.GLOBAL.imgHost + '/images/product/jianbu2.png',
						link:'jianbu'
					},
					{
						icon: '&#xe60f;',
						write: '腰部',
						img: this.GLOBAL.imgHost + '/images/product/yaobu.png',
						imgactive: this.GLOBAL.imgHost + '/images/product/yaobu2.png',
						link:'yaobu'
					},
					{
						icon: '&#xe615;',
						write: '腿部',
						img: this.GLOBAL.imgHost + '/images/product/tuibu.png',
						imgactive: this.GLOBAL.imgHost + '/images/product/tuibu2.png',
						link:'tuibu'
					},
					{
						icon: '&#xe607;',
						write: '脚部',
						img: this.GLOBAL.imgHost + '/images/product/foot.png',
						imgactive: this.GLOBAL.imgHost + '/images/product/foot2.png',
						link:'foot'
					},
				],
				producttotal: [{
						leftList: '随身按摩 | 手法多样 | 一指操控 | 小巧便捷',
						svgName: 'CGD',
						imgs: this.GLOBAL.imgHost + '/images/product/bear.png',
						shopsTitle: '乐范随身魔力按摩贴',
						halfTitle: '口袋里的魔法师',
						cactive: 'molitie',
						choose: 'quanshen',
						url:'https://detail.tmall.com/item.htm?id=557143757149'
					},
					{
						leftList: '加热按摩 | 20档力度 | 智能双控 | 便携收纳',
						imgs: this.GLOBAL.imgHost + '/images/product/warm.png',
						shopsTitle: '乐范魔力贴温情版',
						halfTitle: '有温度的口袋按摩师',
						cactive: 'warm',
						choose: 'quanshen',
						url:'https://item.jd.com/70660829749.html'
					}, {
						leftList: '四驱多路按摩 | 磁吸链接 | App智能操控 | 无线便携',
						imgs: this.GLOBAL.imgHost + '/images/product/siqu.png',
						shopsTitle: '乐范四驱魔力按摩贴 ',
						svgName: 'IF',
						halfTitle: '更专业的随身按摩师',
						cactive: 'siqu',
						choose: 'quanshen',
						url:'https://detail.tmall.com/item.htm?id=598748601388'
					},
					{
						leftList: '经络推拿 | 穴位按摩 | 全身可用 | 小巧便携',
						imgs: this.GLOBAL.imgHost + '/images/product/zhua.png',
						shopsTitle: '乐范小摩爪按摩器',
						halfTitle: '按摩小物  轻巧随行',
						cactive: 'zhua',
						choose: 'quanshen',
						url:'https://item.jd.com/44617830234.html'
					},
					{
						leftList: '仿真按摩 | 揉捏机芯 | 一键操控 | 无线便携',
						imgs: this.GLOBAL.imgHost + '/images/product/egg.png',
						shopsTitle: '乐范小魔蛋趣味按摩仪',
						halfTitle: '养生与艺术  在掌心融合',
						cactive: 'egg',
						choose: 'quanshen',
						url:'https://www.xiaomiyoupin.com/detail?gid=109422'
					}, {
						leftList: '小爱语音交互 | 3D揉捏肩颈 | 超长导轨贴身按摩 | 零重力云端体验',
						imgs: this.GLOBAL.imgHost + '/images/product/chair.png',
						shopsTitle: '乐范一维AI智能按摩椅',
						halfTitle: '按摩  一句话的事儿',
						cactive: 'chair',
						choose: 'quanshen',
						url:'https://detail.tmall.com/item.htm?id=575892509298'
					},
					{
						leftList: '电动升降 | 预防颈椎病 | App站姿管理 | 15Kg动态承重',
						imgs: this.GLOBAL.imgHost + '/images/product/desk.png',
						shopsTitle: '乐班电动电脑升降台',
						halfTitle: '坐站办公  一键切换',
						cactive: 'desk',
						choose: 'quanshen',
						url:'https://www.xiaomiyoupin.com/detail?gid=104011'
					},
					{
						leftList: '三维立体护眼 | 太阳穴按摩 | 手势操控 | 可拆卸清洗',
						imgs: this.GLOBAL.imgHost + '/images/product/eye.png',
						shopsTitle: '乐范灵眸眼部按摩仪',
						halfTitle: '能做“眼保健操”的护眼仪',
						cactive: 'lingmou',
						choose: 'head',
						url:'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.7b773205rsioG5&id=617440666072'
					},
					{
						leftList: '冷热双感敷眼 | 自动感应按摩 | 一键式操作 | 小巧便携',
						imgs: this.GLOBAL.imgHost + '/images/product/eyes.png',
						shopsTitle: '乐范眼部冷热按摩仪',
						halfTitle: '多效合一  宠爱你的双眼',
						cactive: 'coldhot',
						choose: 'head',
						url:'https://detail.tmall.com/item.htm?spm=a220m.1000858.0.0.44499a95ab672C&id=567550623777'
					},
					{
						leftList: '按摩解压 | 放松入眠 | 三点支撑 | 收纳自如',
						imgs: this.GLOBAL.imgHost + '/images/product/neckpillow.png',
						shopsTitle: '乐范按摩助眠颈枕',
						halfTitle: '10分钟  按摩放松  清零压力',
						cactive: 'jingzhen',
						choose: 'head',
						url:'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-15796244175.20.228757597YQIEi&id=562586207011'
					},
					{
						leftList: '通孔透气 | 双弹力海绵 | 冰感面料 | 免拆水洗',
						imgs: this.GLOBAL.imgHost + '/images/product/tanli.png',
						shopsTitle: '乐范双弹力透气U型枕 ',
						halfTitle: '双弹力  让支撑更舒适',
						cactive: 'uxingzhen',
						choose: 'head',
						url:'https://www.xiaomiyoupin.com/detail?gid=118621'
					},
					{
						leftList: '3D按摩 | PTC热敷 | 无线便携 | 强劲扭力',
						imgs: this.GLOBAL.imgHost + '/images/product/rounie.png',
						shopsTitle: '乐范揉捏按摩靠枕',
						halfTitle: '无线按摩  放松不受限',
						cactive: 'kaozhen',
						choose: 'yaobu',
						url:'https://item.jd.com/41309099542.html'
					},
					{
						leftList: '环抱式承托 | 一件升降 | 扭簧设计 | 久坐不累',
						imgs: this.GLOBAL.imgHost + '/images/product/beikao.png',
						shopsTitle: '乐班人体工学可调背靠',
						halfTitle: '科学塑形  舒适依靠',
						cactive: 'kaobei',
						choose: 'yaobu',
						url:'https://detail.tmall.com/item.htm?id=601814725936'
					},
					{
						leftList: '矫正坐姿 | 护腰塑臀 | 立体包裹 | 形体支撑',
						imgs: this.GLOBAL.imgHost + '/images/product/zuodian.png',
						shopsTitle: '乐班护腰塑形坐垫',
						halfTitle: '你的私人坐姿矫正专家',
						cactive: 'zuodian',
						choose: 'yaobu',
						url:'https://detail.tmall.com/item.htm?id=587952281115'
					},
					{
						leftList: '气囊按摩 | 塑造美腿 | 小巧便携 |单双腿可选',
						imgs: this.GLOBAL.imgHost + '/images/product/lega.png',
						shopsTitle: '乐范无线按摩美腿仪',
						halfTitle: '让腿部塑形重归简单',
						cactive: 'meituiyi',
						choose: 'tuibu',
						url:'https://detail.tmall.com/item.htm?id=600594720741'
					},
					{
						leftList: '气囊按摩 | 小巧便携 | 紧密包裹 | 三档可调',
						imgs: this.GLOBAL.imgHost + '/images/product/legb.png',
						shopsTitle: '乐范腿部气压按摩器 ',
						halfTitle: '让腿部塑形重归简单',
						cactive: 'qiyaleg',
						choose: 'tuibu',
						url:'https://detail.tmall.com/item.htm?id=600594720741'
					},
					{
						leftList: '气囊按摩 | 小巧便携 | 紧密包裹 | 三档可调',
						imgs: this.GLOBAL.imgHost + '/images/product/cappa.png',
						shopsTitle: '乐范3D揉捏按摩披肩  ',
						halfTitle: '无线设计  专为肩颈而生',
						cactive: 'cappa',
						choose: 'jianbu',
						url:'https://detail.tmall.com/item.htm?id=587716764745'
					},
					{
						leftList: '仿真揉捏 | 气压按摩 | 热敷理疗 | 透气设计',
						imgs: this.GLOBAL.imgHost + '/images/product/footmassager.png',
						shopsTitle: '乐范脚部揉捏按摩器 ',
						halfTitle: '雅趣养生  心满意足',
						cactive: 'foot',
						choose: 'foot',
						url:'https://detail.tmall.com/item.htm?id=578607134394'
					},
				],
			}
		},
		mounted() {
			this.partflag = this.$route.query.partname|| 'quanshen';
			console.log("globalname",this.activename)
			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
		},
		methods: {
			choosepart(e) {
				console.log(e)
				let that = this
				that.partflag = e
	
			},
			getScroll() {
				let that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let pageWidth = document.documentElement.clientWidth;
				if (scrollTop > 300) {
					that.navstyle = true
				} else {
					that.navstyle = false
				}
			},
			
		}
	}
</script>

<style>
	@font-face {
		font-family: 'iconfont';
		/* project id 1631181 */
		src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot');
		src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot?#iefix') format('embedded-opentype'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff2') format('woff2'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff') format('woff'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.ttf') format('truetype'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: 'iconfont';

	}

	.nav {
		width: 100%;
		/* height: 3.5rem; */
		margin: 0 auto;
		height: 28.375rem;
		line-height: 3.5rem;
		display: flex;
		text-align: center;
		justify-content: space-around;
		position: fixed;
		top: 0rem;
		z-index: 99;
		background-color: white;
	}
	.navshell{
		display: flex;
		text-align: center;
		justify-content: space-around;
	}
	.nav .nav-list {
		width: 3rem;
		/* height: 3rem; */
		/* border-bottom: 1px solid red; */
	}

	.nav span {
		padding-bottom: 0.3rem;
		font-size: 0.9rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
	}

	.nav span.active {
		border-bottom: 0.1rem solid #00C785;
	}

	.partrecommended {
		max-width: 33.75rem;
		margin: 0 auto;
		
	}

	.partrecommended .title {
		width: 100%;
		height: 5.75rem;
		font-size: 2rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		line-height: 5.75rem;
	}

	.centerpart {
		width: 95%;
		clear: both;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
		margin: 0 auto;
		padding-top: 2rem;
		/* padding-bottom: 5rem; */
	}

	.part-icon {
		color: #00C785;
		font-size: 2.5rem;
		margin-top: 15%;
	}

	.part img {
		width: 2.5rem;
		margin-top: 15%;
	}

	.part-write {

		font-size: 0.8rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		/* line-height:81px; */
		opacity: 1;
	}

	.part-write.active {
		color: white;
	}

	.part {
		width: 27.7%;
		/* height: width() * 0.277; */
		background-color: #F0F0F0;
		margin-bottom: 0.625rem;
		/* line-height: 6rem; */
	}

	.part.active {
		background-color: #00C785;
		color: white;
	}

	.product {
		padding-bottom: 2.5rem;
	}

	.product .img {
		width: 85%;
		margin: 0 auto;
		background-color: #ECECEC;
		/* border: 0.0625rem red solid; */
	}

	.product .img img {
		width: 45%;
		/* height: 4%; */
		margin: 0 auto;
		padding-top: 2rem;
		padding-bottom: 2rem;
	}

	.product .product-title {
		width: 85%;
		margin: 0 auto;
		font-size: 1.15rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		text-align: left;
		padding-top: 0.7rem;
	}

	.product .product-write {
		width: 85%;
		margin: 0 auto;
		text-align: left;
		font-size: 0.8rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		padding-top: 0.5rem;
	}

	.product .know {
		border-bottom: 1px solid #1D1D1D;
		padding-bottom: 0.2rem;
		padding-top: 0.7rem;
		font-size:0.9rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(29,29,29,1);
	}

	.product .buy {
		border-bottom: 1px solid #1D1D1D;
		padding-bottom: 0.2rem;
		padding-top: 0.7rem;
		margin-left: 2rem;
		font-size:0.9rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(29,29,29,1);
	}
</style>
